import NotFoundImage from 'assets/images/404/404.svg';
import Text404 from 'assets/images/404/404-text.svg';
import Oops from 'assets/images/404/Ooooops.svg';
import {useNavigate} from 'react-router-dom';
const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="px-5 flex flex-col justify-center h-screen w-screen">
      <img alt="text header" src={Text404} className="block mx-auto mb-6" />
      <img alt="oops" src={Oops} className="block mx-auto mb-6" />
      <img alt="not found" src={NotFoundImage} className="block mx-auto mb-6" />
      <p className=" text-center text-gray-6 font-extrabold">
        صفحه مورد نظر یافت نشد!
      </p>
      <button
        onClick={() => navigate(-1)}
        className=" bg-[#C33025] text-white rounded-lg py-5 text-center w-full mt-16"
      >
        بازگشت
      </button>
    </div>
  );
};

export default NotFound;
